var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    {
      staticClass: "cf-widget_holder",
      attrs: { widget: { title: "Call Flows", iconClass: "fa fa-sitemap" } },
      scopedSlots: _vm._u([
        {
          key: "headerContent",
          fn: function() {
            return [
              _c("div", { staticClass: "header-extra" }, [
                _c("div", { staticClass: "btn-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary m-r-10",
                      attrs: { type: "button", disabled: _vm.isSavingDraft },
                      on: {
                        click: function($event) {
                          return _vm.onSaveDraft()
                        }
                      }
                    },
                    [
                      _vm.isSavingDraft
                        ? _c("Loader", { attrs: { "custom-class": "size-sm" } })
                        : [_vm._v("\n            Save Draft\n          ")]
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary m-r-10",
                      attrs: { type: "button", disabled: _vm.isPublishing },
                      on: {
                        click: function($event) {
                          return _vm.onPublish()
                        }
                      }
                    },
                    [
                      _vm.isPublishing
                        ? _c("Loader", { attrs: { "custom-class": "size-sm" } })
                        : [_vm._v("\n            Publish\n          ")]
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cf-scene__name m-r-15" },
                  [
                    _c("InputText", {
                      model: {
                        value: _vm.callFlowName,
                        callback: function($$v) {
                          _vm.callFlowName = $$v
                        },
                        expression: "callFlowName"
                      }
                    }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa fa-pencil",
                      attrs: { "aria-hidden": "true" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.hasCallFlowErrors
                  ? _c(
                      "div",
                      { staticClass: "cf-error m-r-10" },
                      [
                        _c("i", {
                          staticClass: "fa fa-warning m-r-4",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.callFlowErrors, function(error, index) {
                          return _c("span", { key: index }, [
                            _vm._v(_vm._s(error.errorMessage))
                          ])
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c("CallFlowView", { attrs: { scene: _vm.scene } }),
      _vm._v(" "),
      _vm.showModal
        ? _c("CallFlowReferencesModal", {
            attrs: {
              "call-flow-tree-references": _vm.callFlowTreeReferences,
              "save-draft": _vm.savingDraft
            },
            on: {
              closeModal: _vm.closeModal,
              cloneAndSave: _vm.cloneAndSaveDraftCallFlow,
              save: _vm.publishCallFlow
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }